define('views/linkedcards/linkedcardlistitem',[
    "backbone",
    "text!views/linkedcards/linkedcardlistitem.html",
    "views/_base/baseview",
    "views/linkedcards/editlinkedcard",
    "fancybox"
], function (Backbone, Template, BaseView, EditLCView, Fancybox) {
    "use strict";

    return BaseView.extend({
        template   : _.template(Template),
        scrollToTop: false,
        isRender   : true,
        needsAuth  : false,
        tagName    : "li",
        className  : "linkedCardListItem",
        events     : {
            'click'                             : 'selectPaymentSource',
            'click .js-linkedAccountCardMoreBtn': 'showMoreOptions'
        },
        initialize: function (options) {
            options = options || {};

            this.LCEvents = options.LCEvents;
            _.bindAll(this, "updateCard");
            this.LCEvents.bind("updateCard", this.updateCard);

            this.ecardView = options.ecardView;
            this.elementName = options.elementName;

            if (this.model.StatusID == enums.linkedCardStatuses.PendingLinked) {
                this.model.attributes.NickName += ' : Pending';
                this.model.NickName += ' : Pending';
            }

            BaseView.prototype.initialize(this);
        },
        render: function () {
            var data = this.model.toJSON();

            // Add a Card Image source property to show correct Network Source
            if(data.NetworkSourceID){
                if(data.NetworkSourceID == enums.networkSources.Visa){
                    data.cardImg = 'img/merchants/ecard/visa_logo.png';
                } else if(data.NetworkSourceID == enums.networkSources.MasterCard){
                    data.cardImg = 'img/cards/linked/mastercard_sm.png';
                } else {
                    data.cardImg = 'img/merchants/ecard/visa_logo.png';
                }
            }
            
            this.$el.html(this.template({ data: data }));
            if (this.model.StatusID == enums.linkedCardStatuses.PendingLinked) {
                this.$(".js-editLinkedCard").attr('disabled', 'disabled');
                this.$(".js-editLinkedCard").addClass('disabled');
            }

            return this;
        },
        selectPaymentSource: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = this;

            if(this.ecardView.processingPayment){
                return false;
            }

            if(this.$el.hasClass('selected')){
                this.$el.removeClass('selected');
                this.ecardView.setPaymentSrc(false);
            } else {
                $('.linkedCardListItem').removeClass('selected');
                // this.$el.parent().find('li').each(function(i,me){ $(me).removeClass('selected') });
                this.$el.addClass('selected');
                this.ecardView.setPaymentSrc(this.model);
            }
        },

        updateCard: function (guid, nn) {
            if (this.model.LinkedCardGUID == guid) {
                this.model.attributes.NickName = nn;
                this.render();
            }
        },

        showMoreOptions: function(e){
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }
            console.log('showMoreOptions');
        },

        close: function () {}
    });
});

